/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Doc_Dealership_Work_OrderInputs */

const en_case_doc_dealership_work_order = /** @type {(inputs: Case_Doc_Dealership_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dealership work order`)
};

const pt_br2_case_doc_dealership_work_order = /** @type {(inputs: Case_Doc_Dealership_Work_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OS da concessionária`)
};

/**
* | output |
* | --- |
* | "Dealership work order" |
*
* @param {Case_Doc_Dealership_Work_OrderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_doc_dealership_work_order = /** @type {((inputs?: Case_Doc_Dealership_Work_OrderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Doc_Dealership_Work_OrderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_doc_dealership_work_order(inputs)
	return pt_br2_case_doc_dealership_work_order(inputs)
});